module.exports = __webpack_public_path__ + "static/media/19a-03_ST-2019-165x133cm-oleo-sobre-tela.ec4cc765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-03_ST-2019-165x133cm-oleo-sobre-tela.jpg
// module id = 238
// module chunks = 0